// extracted by mini-css-extract-plugin
export default {"tool-panel":"tojfJhFqkDkuFP6r1Kpl","toolPanel":"tojfJhFqkDkuFP6r1Kpl"};